import { useEffect, useRef, useState } from 'react';
import { GameContext } from '../components/hud/GameContext';
import { Hud } from '../components/hud/Hud';
import { Game } from '../game/core/game';
import { useSession } from '../stores/session-store';
import '../styles/hud.css';

/** Hosts the WebGL game and the React HUD on top of it. */
export function GameScreen() {
  const character = useSession((s) => s.character);
  const host = useRef<HTMLDivElement>(null);
  const [game, setGame] = useState<Game | null>(null);
  const [error, setError] = useState<string | null>(null);

  const leave = (): void => {
    useSession.getState().go('characters');
  };

  useEffect(() => {
    if (!host.current || !character) return;
    let g: Game | null = null;
    try {
      g = new Game({ container: host.current, characterId: character.id, onExit: leave });
      setGame(g);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to start the game (WebGL unavailable?)');
    }
    return () => {
      g?.dispose();
      setGame(null);
    };
  }, [character]);

  if (!character) {
    useSession.getState().go('characters');
    return null;
  }
  return (
    <div className="game-root" ref={host}>
      {error ? (
        <div className="kick-overlay">
          <h2 className="gold">Could not start the game</h2>
          <p className="muted">{error}</p>
          <button className="btn btn-primary" onClick={leave}>
            Back
          </button>
        </div>
      ) : (
        <GameContext.Provider value={game}>{game && <Hud onLeave={leave} />}</GameContext.Provider>
      )}
    </div>
  );
}
